var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-estates-item-legal-banking"},[_c('ui-form',{attrs:{"model":_vm.fields,"validation":_vm.validation,"submit-handler":_vm.submitHandler,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }